module.exports = __webpack_public_path__ + "static/Cority-15d63d2e8aabecea988be97057430a5c.pdf";